import PropTypes from 'prop-types';
import { dobInWords } from '@/utils/dobText';

/**
 * The travelers as they'll be sent to the airline, shown once more before
 * payment: name and date of birth in words. A slip in either is hard to fix
 * after booking (customers can't edit travelers once booked), and a date
 * written out ("June 30, 1980") is far easier to catch than 06/30/1980.
 */
export default function CheckoutTravelerReview({ passengers = [], onEdit }) {
  if (!passengers.length) return null;
  const nameOf = (p) => [p.first_name, p.middle_name, p.last_name]
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(' ');
  return (
    <div className="w-full max-w-2xl mx-auto mb-4 text-left rounded-2xl border border-white/10 bg-white/[0.03] p-4 sm:p-5" data-testid="checkout-traveler-review">
      <div className="flex items-center justify-between gap-3 mb-1">
        <p className="text-sm font-normal text-white">Travelers</p>
        {onEdit && (
          <button
            type="button"
            onClick={onEdit}
            className="text-xs font-normal text-brand-300 hover:text-brand-200 underline-offset-2 hover:underline"
          >
            Edit
          </button>
        )}
      </div>
      <p className="text-xs font-normal text-white/50 mb-3">
        Names and birth dates must match each traveler&rsquo;s passport or ID exactly.
      </p>
      <ul className="space-y-2">
        {passengers.map((p, i) => (
          <li key={p.id || i} className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-0.5 text-sm font-normal">
            <span className="text-white/90">{nameOf(p) || `Traveler ${i + 1}`}</span>
            <span className="text-white/60">
              {dobInWords(p.date_of_birth) ? `Born ${dobInWords(p.date_of_birth)}` : 'Birth date missing'}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

CheckoutTravelerReview.propTypes = {
  /** The checkout's travelers: first/middle/last name and ISO date_of_birth. */
  passengers: PropTypes.arrayOf(PropTypes.object),
  /** Reopens the traveler form. */
  onEdit: PropTypes.func,
};
